define('main',['modules/player'], function(player) {
    // init
    player.init();
    return player;
});
